import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AppProviders } from './app/providers';
import { createRouter } from './app/router';
import { RouteFallback } from './app/layout/route-fallback';
import { Devtools } from './app/devtools';

/*
 * The three typefaces `gkiserpong.org` runs (`src/app/theme.ts` assigns them):
 * Archivo for the brand lockup, Raleway for headings, Roboto for body and
 * tables.
 *
 * Imported as **latin subsets of four fixed weights**, not the packages'
 * `index.css`, which would pull every subset of every weight each family
 * publishes — for Roboto alone that is nine, in both roman and italic. This
 * app's UI is Bahasa Indonesia (docs/07 §0), its headings are one weight, and
 * `fontWeightStrong` is set to 700 so the bold it asks for is a real file
 * rather than a synthesised smear of the regular. Four files, ~81 kB of woff2,
 * all `font-display: swap`, served from this origin because `font-src 'self'`
 * in index.html leaves no other option.
 */
import '@fontsource/archivo/latin-700.css';
import '@fontsource/raleway/latin-600.css';
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-700.css';

import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root is missing from index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <Suspense fallback={<RouteFallback />}>
        <RouterProvider router={createRouter()} />
      </Suspense>
      <Devtools />
    </AppProviders>
  </StrictMode>,
);
